<template>
  <div>
    <top-bar heading="Edit Section"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <div class="row">
        <div class="col-9">
          <b-card class="p-3">
            <div class="col-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="section_name">Section Name</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('section_name')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Section Name"
                      data-vv-name="section_name"
                      type="text"
                      placeholder="Section Name"
                      name="section_name"
                      id="section_name"
                      v-model="section.name"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('section_name')">{{ errors.first('section_name') }}</div>
            </div>
            <div class="col mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="section_published">Section Status</label>
              <select :class="{'form-control': true, 'is-invalid': errors.has('unit_published')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Section Status"
                      data-vv-name="section_published"
                      type="text"
                      name="section_published"
                      id="section_published"
                      v-model="section.published"
                      :disabled="!$auth.check('super_admin')">
                <option :value="false">Draft</option>
                <option :value="true">Published</option>
              </select>
              <div class="invalid-tooltip d-block" v-if="errors.has('unit_published')">{{ errors.first('section_published') }}</div>
            </div>
            <div class="col mb-3">
              <loading-button :loading="loading" variant="primary" block @submit="saveSection">Save Section</loading-button>
            </div>
            <div class="col">
                <b-form-radio-group
                        id="btn-radios-2"
                        v-model="preview"
                        :options="[{text: 'Edit', value: false}, {text: 'Preview', value:true}]"
                        buttons
                        block
                        button-variant="outline-info"
                        size="sm"
                        name="radio-btn-outline"
                ></b-form-radio-group>
            </div>
          </b-card>
        </div>
      </div>

      <template v-if="!preview">
        <div class="row mt-3">
          <div class="col-9">
            <div class="col-12">
              <h3 class="page-header page-header-underline">Content Sections</h3>
            </div>
            <course-builder v-model="section.content"></course-builder>
          </div>
          <div class="col">
            <div class="col-12">
              <h3 class="page-header page-header-underline">Content Sections</h3>
            </div>
            <div class="card">
              <div class="card-body">
                <table class="table table-no-border text-blue">
                  <tbody>
                    <tr>
                      <td class="pointer" @click="addComponent('content','heading')">
                        <font-awesome-icon icon="font" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Heading</span>
                      </td>
                      <td class="pointer" @click="addComponent('content','text-block')">
                        <font-awesome-icon icon="text-width" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Textblock</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pointer" @click="addComponent('content','audio')">
                        <font-awesome-icon icon="volume-up" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Audio</span>
                      </td>
                      <td class="pointer" @click="addComponent('content','divider')">
                        <font-awesome-icon icon="bars" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Space</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pointer" @click="addComponent('content','file')">
                        <font-awesome-icon icon="file" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Document</span>
                      </td>
                      <td class="pointer" @click="addComponent('content','image')">
                        <font-awesome-icon icon="file-image" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Image</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pointer" @click="addComponent('content','video')">
                        <font-awesome-icon icon="play-circle" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Video</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-9">
            <div class="col-12">
              <h3 class="page-header page-header-underline">Learning Activity</h3>
            </div>
            <course-builder v-model="section.learning"></course-builder>
          </div>
          <div class="col">
            <div class="col-12">
              <h3 class="page-header page-header-underline">Content Sections</h3>
            </div>
            <div class="card">
              <div class="card-body">
                <table class="table table-no-border text-blue">
                  <tbody>
                    <tr>
                      <td class="pointer" @click="addComponent('learning','heading')">
                        <font-awesome-icon icon="font" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Heading</span>
                      </td>
                      <td class="pointer" @click="addComponent('learning','text-block')">
                        <font-awesome-icon icon="text-width" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Textblock</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pointer" @click="addComponent('learning','audio')">
                        <font-awesome-icon icon="volume-up" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Audio</span>
                      </td>
                      <td class="pointer" @click="addComponent('learning','divider')">
                        <font-awesome-icon icon="bars" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Space</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pointer" @click="addComponent('learning','file')">
                        <font-awesome-icon icon="file" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Document</span>
                      </td>
                      <td class="pointer" @click="addComponent('learning','image')">
                        <font-awesome-icon icon="file-image" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Image</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pointer" @click="addComponent('learning','video')">
                        <font-awesome-icon icon="play-circle" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Video</span>
                      </td>
                      <td class="pointer" @click="addComponent('learning','learning-activity')">
                        <font-awesome-icon icon="solar-panel" size="2x"></font-awesome-icon>
                        <span class="ml-2 text-black font150">Learning Activity</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <div class="p-lg-5 p-3 text-center text-md-left mt-5 bg-white p-2" style="border-top: 2px dashed #CFD8EE; border-bottom: 2px dashed #CFD8EE;">
            <course-viewer :field="field" v-for="field in section.content" :key="field.id"></course-viewer>
          </div>
        </div>
        <div>
          <div class="p-lg-5 p-3 text-center text-md-left mt-5 bg-white p-2" style="border-top: 2px dashed #CFD8EE; border-bottom: 2px dashed #CFD8EE;">
            <course-viewer :field="field" v-for="field in section.learning" :key="field.id"></course-viewer>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import CourseBuilder from '../../components/CourseBuilder/Builder'
import sortBy from 'lodash-es/sortBy'
import cloneDeep from 'lodash-es/cloneDeep'
import CourseViewer from '../../components/CourseViewer'

export default {
  name: 'EditSection',
  components: { CourseViewer, CourseBuilder },
  data () {
    return {
      preview: false,
      section: {
        content: [],
        learning: []
      },
      loaded: false,
      loading: false,
      componentTypes: {
        heading: 1,
        divider: 2,
        'text-block': 3,
        image: 4,
        gallery: 5,
        audio: 6,
        video: 7,
        file: 8,
        'learning-activity': 9
      },
      componentAreas: {
        content: 1,
        contentMedia: 2,
        learning: 3,
        learningMedia: 4
      }
    }
  },
  methods: {
    loadSection () {
      this.loaded = false
      this.axios.get('/sections/' + this.id, { params: { includes: 'components' } }).then(rsp => {
        rsp.data.data.content = sortBy(rsp.data.data.content, 'ordinal')
        rsp.data.data.learning = sortBy(rsp.data.data.learning, 'ordinal')
        this.section = rsp.data.data
        this.loaded = true
      }).catch(err => this.$snotify.error(err.response.data.message))
    },
    saveSection () {
      this.loading = true

      let section = cloneDeep(this.section)
      section.content = this.buildComponentPayload(section.content)
      section.learning = this.buildComponentPayload(section.learning)

      this.axios.put('/sections/' + this.id, section).then(rsp => {
        this.$snotify.success('Section Updated')
        this.section = rsp.data.data
        this.loading = false
      }).catch(err => this.$errorOut(err))
    },
    addComponent (componentArea, componentType) {
      const componentAreaId = this.componentAreas[componentArea]
      const componentTypeId = this.componentTypes[componentType]

      const componentDefault = {
        'course_id': this.section.course_id,
        'module_id': this.section.module_id,
        'section_id': this.section.id,
        'component_area_id': componentAreaId,
        'component_area': {
          'id': componentAreaId,
          'name': componentArea
        },
        'component_type_id': componentTypeId,
        'component_type': {
          'id': componentTypeId,
          'name': componentType
        },
        'ordinal': this.section[componentArea].length + 1,
        'data': ''
      }
      this.axios.post('/components', componentDefault).then(rsp => {
        this.section[componentArea].push(rsp.data)
      })
    },
    buildComponentPayload (components) {
      return components.map(component => {
        return {
          id: component.id,
          component_area_id: component.component_area_id,
          component_type_id: component.component_type_id,
          data: component.data,
          ordinal: component.ordinal,
          course_id: this.section.course_id,
          module_id: this.section.module_id,
          section_id: this.section.id
        }
      })
    }
  },
  mounted () {
    this.loadSection()
  },
  metaInfo: {
    title: 'Edit Section'
  },
  props: ['id']
}
</script>
